export interface Apartment {
  id: string;
  title: string;
  type: string;
  transaction: 'location' | 'vente';
  city: string;
  quartier: string;
  price: number;
  bedrooms: number;
  bathrooms: number;
  surface: number;
  description: string;
  images: string[];
  available: boolean;
  ownerType: 'proprietaire' | 'agence';
  ownerName: string;
  ownerPhone: string;
  amenities: string[];
  postedAt: string;
  featured: boolean;
}

export const apartments: Apartment[] = [
  {
    id: 'apt-001',
    title: 'Appartement moderne 3 chambres à Agoè',
    type: 'Appartement',
    transaction: 'location',
    city: 'Lomé',
    quartier: 'Agoè',
    price: 350000,
    bedrooms: 3,
    bathrooms: 2,
    surface: 120,
    description: 'Magnifique appartement moderne au cœur d\'Agoè, entièrement climatisé avec cuisine équipée, salon spacieux et balcon offrant une vue dégagée. Situé dans une résidence sécurisée avec parking privé, à proximité des commerces et des écoles.',
    images: [
      'https://readdy.ai/api/search-image?query=Modern%20three%20bedroom%20apartment%20living%20room%20with%20bright%20natural%20light%2C%20contemporary%20furniture%2C%20white%20walls%2C%20wooden%20floors%2C%20large%20windows%2C%20African%20urban%20home%2C%20professional%20real%20estate%20photography%2C%20warm%20inviting%20tones&width=1200&height=800&seq=apt-001-a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Modern%20kitchen%20with%20marble%20countertop%20and%20white%20cabinets%2C%20stainless%20steel%20appliances%2C%20bright%20lighting%2C%20contemporary%20African%20apartment%20interior%2C%20professional%20real%20estate%20photography&width=1200&height=800&seq=apt-001-b&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Cozy%20modern%20bedroom%20with%20queen%20bed%2C%20neutral%20tones%2C%20large%20window%20with%20curtains%2C%20wooden%20floor%2C%20African%20urban%20apartment%2C%20warm%20natural%20light%2C%20real%20estate%20photography&width=1200&height=800&seq=apt-001-c&orientation=landscape',
    ],
    available: true,
    ownerType: 'agence',
    ownerName: 'Apeiron Immobilier',
    ownerPhone: '+228 90 11 22 33',
    amenities: ['Climatisation', 'Parking', 'Groupe électrogène', 'Balcon', 'Cuisine équipée', 'Gardien'],
    postedAt: '2026-08-12',
    featured: true,
  },
  {
    id: 'apt-002',
    title: 'Villa de standing 4 chambres à Baguida',
    type: 'Villa',
    transaction: 'vente',
    city: 'Lomé',
    quartier: 'Baguida',
    price: 185000000,
    bedrooms: 4,
    bathrooms: 3,
    surface: 320,
    description: 'Superbe villa de standing avec jardin arboré, piscine privée et terrasse. Construction récente de haute qualité, finitions soignées, grand séjour lumineux et suite parentale. Idéale pour une famille exigeante recherchant calme et confort.',
    images: [
      'https://readdy.ai/api/search-image?query=Luxury%20modern%20villa%20exterior%20with%20swimming%20pool%2C%20tropical%20garden%2C%20contemporary%20architecture%2C%20warm%20sunset%20lighting%2C%20African%20coastal%20residence%2C%20professional%20real%20estate%20photography&width=1200&height=800&seq=apt-002-a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Spacious%20luxury%20living%20room%20with%20high%20ceiling%2C%20elegant%20furniture%2C%20floor%20to%20ceiling%20windows%2C%20modern%20African%20villa%20interior%2C%20warm%20lighting%2C%20professional%20photography&width=1200&height=800&seq=apt-002-b&orientation=landscape',
    ],
    available: true,
    ownerType: 'proprietaire',
    ownerName: 'M. Koffi Mensah',
    ownerPhone: '+228 91 44 55 66',
    amenities: ['Piscine', 'Jardin', 'Climatisation', 'Parking', 'Groupe électrogène', 'Eau de forage'],
    postedAt: '2026-08-15',
    featured: true,
  },
  {
    id: 'apt-003',
    title: 'Studio meublé à Kodjoviakopé',
    type: 'Studio',
    transaction: 'location',
    city: 'Lomé',
    quartier: 'Kodjoviakopé',
    price: 150000,
    bedrooms: 1,
    bathrooms: 1,
    surface: 35,
    description: 'Studio entièrement meublé et équipé dans un quartier prisé et animé de Lomé. Proche de la plage et des restaurants, parfait pour un jeune professionnel ou un expatrié. Eau et électricité disponibles en permanence.',
    images: [
      'https://readdy.ai/api/search-image?query=Cozy%20furnished%20studio%20apartment%2C%20compact%20modern%20layout%2C%20bed%20sofa%20kitchenette%2C%20bright%20natural%20light%2C%20clean%20minimal%20African%20urban%20interior%2C%20professional%20real%20estate%20photography&width=1200&height=800&seq=apt-003-a&orientation=landscape',
    ],
    available: true,
    ownerType: 'agence',
    ownerName: 'Immo Togo Plus',
    ownerPhone: '+228 92 33 44 55',
    amenities: ['Meublé', 'Climatisation', 'Internet fibre', 'Eau courante'],
    postedAt: '2026-08-18',
    featured: false,
  },
  {
    id: 'apt-004',
    title: 'Duplex spacieux à Adidogomé',
    type: 'Duplex',
    transaction: 'location',
    city: 'Lomé',
    quartier: 'Adidogomé',
    price: 280000,
    bedrooms: 4,
    bathrooms: 3,
    surface: 180,
    description: 'Grand duplex familial avec cour privée, garage pour deux voitures et cuisine extérieure. Quartier résidentiel calme, proche de l\'université et des axes principaux. Idéal pour une grande famille.',
    images: [
      'https://readdy.ai/api/search-image?query=Spacious%20duplex%20house%20exterior%20with%20private%20courtyard%2C%20modern%20African%20residential%20architecture%2C%20clean%20facade%2C%20daylight%2C%20professional%20real%20estate%20photography&width=1200&height=800&seq=apt-004-a&orientation=landscape',
    ],
    available: true,
    ownerType: 'proprietaire',
    ownerName: 'Mme Adjoa Lawson',
    ownerPhone: '+228 93 66 77 88',
    amenities: ['Garage', 'Cour', 'Cuisine extérieure', 'Climatisation', 'Gardien'],
    postedAt: '2026-08-10',
    featured: false,
  },
  {
    id: 'apt-005',
    title: 'Appartement 2 chambres à Tokoin',
    type: 'Appartement',
    transaction: 'location',
    city: 'Lomé',
    quartier: 'Tokoin',
    price: 180000,
    bedrooms: 2,
    bathrooms: 1,
    surface: 75,
    description: 'Appartement fonctionnel de 2 chambres dans un immeuble sécurisé avec ascenseur. Proche des marchés, écoles et transports en commun. Cuisine semi-équipée et séjour lumineux.',
    images: [
      'https://readdy.ai/api/search-image?query=Two%20bedroom%20apartment%20interior%2C%20bright%20living%20room%20with%20sofa%20and%20dining%20area%2C%20modern%20African%20urban%20home%2C%20natural%20light%2C%20professional%20real%20estate%20photography&width=1200&height=800&seq=apt-005-a&orientation=landscape',
    ],
    available: false,
    ownerType: 'agence',
    ownerName: 'Apeiron Immobilier',
    ownerPhone: '+228 90 11 22 33',
    amenities: ['Ascenseur', 'Sécurité 24h', 'Parking', 'Eau courante'],
    postedAt: '2026-07-28',
    featured: false,
  },
  {
    id: 'apt-006',
    title: 'Terrain titré à Adidoadin',
    type: 'Terrain',
    transaction: 'vente',
    city: 'Lomé',
    quartier: 'Adidoadin',
    price: 45000000,
    bedrooms: 0,
    bathrooms: 0,
    surface: 600,
    description: 'Terrain de 600 m² entièrement titré, situé dans une zone en pleine expansion. Accès facile par route bitumée, idéal pour construction résidentielle ou projet immobilier. Documents en règle.',
    images: [
      'https://readdy.ai/api/search-image?query=Empty%20residential%20land%20plot%20with%20clear%20sky%2C%20flat%20green%20terrain%2C%20African%20suburban%20area%2C%20real%20estate%20listing%20photography%2C%20daylight&width=1200&height=800&seq=apt-006-a&orientation=landscape',
    ],
    available: true,
    ownerType: 'proprietaire',
    ownerName: 'M. Yao Adjovi',
    ownerPhone: '+228 94 55 66 77',
    amenities: ['Titre foncier', 'Route bitumée', 'Eau et électricité à proximité'],
    postedAt: '2026-08-05',
    featured: false,
  },
  {
    id: 'apt-007',
    title: 'Bureau moderne à Nyékonakpoè',
    type: 'Bureau',
    transaction: 'location',
    city: 'Lomé',
    quartier: 'Nyékonakpoè',
    price: 400000,
    bedrooms: 0,
    bathrooms: 2,
    surface: 90,
    description: 'Espace de bureaux moderne et entièrement climatisé au cœur du quartier des affaires de Lomé. Open space aménageable, salle de réunion et parking. Idéal pour startup ou PME en croissance.',
    images: [
      'https://readdy.ai/api/search-image?query=Modern%20office%20space%20with%20glass%20partitions%2C%20open%20plan%20layout%2C%20ergonomic%20desks%2C%20bright%20natural%20light%2C%20African%20business%20district%2C%20professional%20real%20estate%20photography&width=1200&height=800&seq=apt-007-a&orientation=landscape',
    ],
    available: true,
    ownerType: 'agence',
    ownerName: 'Immo Togo Plus',
    ownerPhone: '+228 92 33 44 55',
    amenities: ['Climatisation', 'Internet fibre', 'Salle de réunion', 'Parking', 'Sécurité'],
    postedAt: '2026-08-16',
    featured: true,
  },
  {
    id: 'apt-008',
    title: 'Résidence hôtelière à Hédzranawoé',
    type: 'Appartement',
    transaction: 'location',
    city: 'Lomé',
    quartier: 'Hédzranawoé',
    price: 220000,
    bedrooms: 2,
    bathrooms: 2,
    surface: 85,
    description: 'Bel appartement de 2 chambres avec salles de bain privatives dans une résidence moderne et calme. Accès sécurisé, générateur de secours et parking couvert. Proche du grand marché et des banques.',
    images: [
      'https://readdy.ai/api/search-image?query=Elegant%20two%20bedroom%20apartment%20with%20modern%20decor%2C%20neutral%20color%20palette%2C%20bright%20living%20space%2C%20African%20urban%20residence%2C%20professional%20real%20estate%20photography&width=1200&height=800&seq=apt-008-a&orientation=landscape',
    ],
    available: true,
    ownerType: 'proprietaire',
    ownerName: 'Mme Ami Kpodar',
    ownerPhone: '+228 95 77 88 99',
    amenities: ['Climatisation', 'Parking couvert', 'Groupe électrogène', 'Gardien'],
    postedAt: '2026-08-14',
    featured: false,
  },
  {
    id: 'apt-009',
    title: 'Penthouse de luxe à Cacaveli',
    type: 'Appartement',
    transaction: 'vente',
    city: 'Lomé',
    quartier: 'Cacaveli',
    price: 220000000,
    bedrooms: 3,
    bathrooms: 3,
    surface: 200,
    description: 'Penthouse d\'exception au dernier étage avec vue panoramique sur la ville et l\'océan. Finitions haut de gamme, terrasse privée, jacuzzi et service de conciergerie. Un bien rare sur le marché loméen.',
    images: [
      'https://readdy.ai/api/search-image?query=Luxury%20penthouse%20terrace%20with%20panoramic%20city%20and%20ocean%20view%2C%20jacuzzi%2C%20elegant%20outdoor%20furniture%2C%20dusk%20lighting%2C%20African%20coastal%20city%2C%20professional%20real%20estate%20photography&width=1200&height=800&seq=apt-009-a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=Luxury%20penthouse%20interior%20with%20designer%20furniture%2C%20marble%20floors%2C%20floor%20to%20ceiling%20windows%2C%20panoramic%20view%2C%20African%20modern%20architecture%2C%20professional%20photography&width=1200&height=800&seq=apt-009-b&orientation=landscape',
    ],
    available: true,
    ownerType: 'agence',
    ownerName: 'Apeiron Immobilier',
    ownerPhone: '+228 90 11 22 33',
    amenities: ['Terrasse', 'Jacuzzi', 'Vue mer', 'Conciergerie', 'Parking', 'Sécurité 24h'],
    postedAt: '2026-08-19',
    featured: true,
  },
  {
    id: 'apt-010',
    title: 'Maison familiale à Attiégou',
    type: 'Villa',
    transaction: 'location',
    city: 'Lomé',
    quartier: 'Attiégou',
    price: 300000,
    bedrooms: 5,
    bathrooms: 3,
    surface: 240,
    description: 'Grande maison familiale avec jardin, véranda et dépendance pour personnel. Quartier résidentiel verdoyant et sécurisé. Parfaite pour une famille nombreuse recherchant espace et tranquillité.',
    images: [
      'https://readdy.ai/api/search-image?query=Large%20family%20house%20with%20garden%20and%20veranda%2C%20tropical%20plants%2C%20modern%20African%20residential%20home%2C%20bright%20daylight%2C%20professional%20real%20estate%20photography&width=1200&height=800&seq=apt-010-a&orientation=landscape',
    ],
    available: true,
    ownerType: 'proprietaire',
    ownerName: 'M. Kodjo Amegah',
    ownerPhone: '+228 96 88 99 00',
    amenities: ['Jardin', 'Véranda', 'Dépendance', 'Garage', 'Eau de forage'],
    postedAt: '2026-08-08',
    featured: false,
  },
];

export const apartmentTypes = [
  'Appartement',
  'Villa',
  'Studio',
  'Duplex',
  'Terrain',
  'Bureau',
];

export const apartmentQuartiers = [
  'Agoè',
  'Baguida',
  'Kodjoviakopé',
  'Adidogomé',
  'Tokoin',
  'Adidoadin',
  'Nyékonakpoè',
  'Hédzranawoé',
  'Cacaveli',
  'Attiégou',
];